module.exports = __webpack_public_path__ + "static/media/report_admin.245936fd.svg";